class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');

    this.detailsContainer.addEventListener('keyup', (event) => event.code.toUpperCase() === 'ESCAPE' && this.close());
    this.summaryToggle.addEventListener('click', this.onSummaryClick.bind(this));
    this.querySelector('button[type="button"]').addEventListener('click', this.close.bind(this));

    this.summaryToggle.setAttribute('role', 'button');

    // Check if this is a search modal
    this.isSearchModal = this.classList.contains('header__search');
  }

  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }

  onSummaryClick(event) {
    event.preventDefault();
    event.target.closest('details').hasAttribute('open') ? this.close() : this.open(event);
  }

  onBodyClick(event) {
    if (!this.contains(event.target) || event.target.classList.contains('modal-overlay')) this.close(false);
  }

  open(event) {
    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
    event.target.closest('details').setAttribute('open', true);
    document.body.addEventListener('click', this.onBodyClickEvent);
    document.body.classList.add('overflow-hidden');

    // If this is a search modal, hide other header elements
    if (this.isSearchModal && window.innerWidth >= 750) {
      this.hideOtherHeaderElements();
    }

    trapFocus(
      this.detailsContainer.querySelector('[tabindex="-1"]'),
      this.detailsContainer.querySelector('input:not([type="hidden"])')
    );
  }

  close(focusToggle = true) {
    removeTrapFocus(focusToggle ? this.summaryToggle : null);
    this.detailsContainer.removeAttribute('open');
    document.body.removeEventListener('click', this.onBodyClickEvent);
    document.body.classList.remove('overflow-hidden');

    // If this is a search modal, show other header elements
    if (this.isSearchModal && window.innerWidth >= 750) {
      this.showOtherHeaderElements();
    }
  }

  hideOtherHeaderElements() {
    const header = document.querySelector('.header');
    if (!header) return;

    // Hide inline menu
    const inlineMenu = header.querySelector('.header__inline-menu');
    if (inlineMenu) {
      inlineMenu.style.opacity = '0';
      inlineMenu.style.visibility = 'hidden';
      inlineMenu.style.pointerEvents = 'none';
    }

    // Hide other icons
    const iconsContainer = header.querySelector('.header__icons');
    if (iconsContainer) {
      const searchIcon = iconsContainer.querySelector('.header__icon--search');
      iconsContainer.querySelectorAll('.header__icon').forEach(icon => {
        if (icon !== searchIcon) {
          icon.style.opacity = '0';
          icon.style.visibility = 'hidden';
          icon.style.pointerEvents = 'none';
        }
      });
    }

    // Hide localization wrapper
    const localizationWrapper = iconsContainer?.querySelector('.desktop-localization-wrapper');
    if (localizationWrapper) {
      localizationWrapper.style.opacity = '0';
      localizationWrapper.style.visibility = 'hidden';
    }

    // Hide logo
    const logo = header.querySelector('.header__heading-link');
    if (logo) {
      logo.style.opacity = '0';
      logo.style.pointerEvents = 'none';
    }
  }

  showOtherHeaderElements() {
    const header = document.querySelector('.header');
    if (!header) return;

    // Show inline menu
    const inlineMenu = header.querySelector('.header__inline-menu');
    if (inlineMenu) {
      inlineMenu.style.opacity = '';
      inlineMenu.style.visibility = '';
      inlineMenu.style.pointerEvents = '';
    }

    // Show other icons
    const iconsContainer = header.querySelector('.header__icons');
    if (iconsContainer) {
      iconsContainer.querySelectorAll('.header__icon').forEach(icon => {
        icon.style.opacity = '';
        icon.style.visibility = '';
        icon.style.pointerEvents = '';
      });
    }

    // Show localization wrapper
    const localizationWrapper = iconsContainer?.querySelector('.desktop-localization-wrapper');
    if (localizationWrapper) {
      localizationWrapper.style.opacity = '';
      localizationWrapper.style.visibility = '';
    }

    // Show logo
    const logo = header.querySelector('.header__heading-link');
    if (logo) {
      logo.style.opacity = '';
      logo.style.pointerEvents = '';
    }
  }
}

customElements.define('details-modal', DetailsModal);
